/* ==========================================================================
   Sticky conversion bar — reveal + dismiss
   Ships as: assets/event-stickybar.js  (loaded with defer)

   The countdown inside the bar is handled by event-countdown.js, which drives
   every [data-countdown] on the page. This file only decides when the bar is
   on screen.

   Reveal rule: the bar stays hidden while section 1 is in view and appears
   once it has scrolled past. Section 1 already carries the countdown, venue
   and booking CTA, so showing the bar there would put two competing copies of
   the same call to action on screen at once. It hides again once the theme
   footer comes into view — there's nothing left below it to sit in front of,
   and leaving it up would reserve dead padding-bottom above the footer.

   The bar is not user-dismissible by design — it is the persistent CTA.
   ========================================================================== */

(function () {
  'use strict';

  var bar = document.getElementById('event-stickybar');
  if (!bar) return;

  // the page is a wrapper div in the theme, not <body>
  var root = document.querySelector('.event-page') || document.body;

  /* ---- show / hide ------------------------------------------------------ */

  function show() {
    if (bar.hasAttribute('data-visible')) return;
    bar.hidden = false;
    // measure after unhiding so the page reserves the right amount of room
    window.requestAnimationFrame(function () {
      root.setAttribute('data-stickybar', '');
      root.style.setProperty('--e-stickybar-h', bar.offsetHeight + 'px');
      bar.setAttribute('data-visible', '');
    });
  }

  function hide() {
    bar.removeAttribute('data-visible');
    root.removeAttribute('data-stickybar');
    root.style.removeProperty('--e-stickybar-h');
  }

  /* ---- reveal trigger --------------------------------------------------- */

  var trigger = document.querySelector('[data-stickybar-trigger]');
  // the theme's global footer — once it's reached there is nothing left for
  // the bar to sit in front of, and the reserved padding-bottom would just
  // read as a dead gap above it
  var footer = document.getElementById('velaFooter');

  var pastHero = false;
  var nearFooter = false;

  function sync() {
    if (pastHero && !nearFooter) show(); else hide();
  }

  if (trigger && 'IntersectionObserver' in window) {
    // threshold 0 + no rootMargin: fires the moment the last pixel of
    // section 1 leaves the viewport, and again when it scrolls back in
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        pastHero = !entry.isIntersecting;
        sync();
      });
    }, { threshold: 0 }).observe(trigger);
  } else {
    // fallback: reveal once scrolled past the trigger's height
    var onScroll = function () {
      pastHero = trigger
        ? window.scrollY > (trigger.offsetTop + trigger.offsetHeight)
        : window.scrollY > window.innerHeight;
      sync();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        nearFooter = entry.isIntersecting;
        sync();
      });
    }, { threshold: 0 }).observe(footer);
  }

  window.addEventListener('resize', function () {
    if (bar.hasAttribute('data-visible')) {
      root.style.setProperty('--e-stickybar-h', bar.offsetHeight + 'px');
    }
  });
})();
